<div class="scheduling-alarm-toggle _flex-row-centered">
  <span translate>Alert</span>
  <rotec-toggle-v2
    [active]="isAlarmActive"
    (activeChange)="isAlarmActive = $event"
    activeLabel="Yes"
    inactiveLabel="No"
  ></rotec-toggle-v2>
</div>

@if (isAlarmActive) {
  <div class="scheduling-alarm-container" (focusout)="touched()">
    <div class="scheduling-alarm-settings">
      <rotec-number-input-panel-v2
        [darkMode]="true"
        [min]="1"
        [value]="offsetValue"
        (valueChange)="offsetValue = $event"
      ></rotec-number-input-panel-v2>
      <rotec-select-v2
        [darkMode]="true"
        [secondary]="true"
        [selectedItem]="offsetUnit"
        (selectedItemChange)="offsetUnit = $event"
        [items]="alarmIntervalItems"
      ></rotec-select-v2>
      <span translate>Before next execution date</span>
    </div>
    <div class="scheduling-alarm-alert-distributor">
      <p translate>Alert distributor</p>
      <p class="rc-ml-5 rc-mr-5">
        <rotec-icon-v2
          [svgIcon]="!formControl?.valid ? 'asterisk' : 'check'"
          [color]="!formControl?.valid ? 'pink' : 'gray'"
        ></rotec-icon-v2>
      </p>
      <rotec-textarea-v2
        [value]="additionalEmails"
        (valueChange)="additionalEmails = $event"
        [darkMode]="true"
        minHeight="100px"
        name="Email"
        placeholder="{{ 'Add additional addressees (\';\' separated)' | translate }}"
      ></rotec-textarea-v2>
    </div>
    @if (formControl?.touched && formControl?.errors?.noRecipients; as error) {
      <div class="error-message" translate>
        {{ error }}
      </div>
    }
  </div>
}
